<template>
    <div class="quiz-time-out">
        <img src="@/assets/images/quiz-time-out.png" class="quiz-time-out__image" alt="" />
        <span class="quiz-time-out__header" v-html="$t('Quiz.time_out_header')"></span>
        <span class="quiz-time-out__description" v-html="$t('Quiz.time_out_description')"></span>
        <TotemButton color="primary" @click="retakeTest" label="Retake the test" icon="arrow-right" iconPosition="right" />
    </div>
</template>

<script>
    export default {
        name: 'quiz-time-out',
        methods: {
            retakeTest () {
                this.$emit('retake-test')
            }
        }
    }
</script>

<style lang="scss" scoped>
.quiz-time-out {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    max-width: 686px;
    margin: 0 auto;
    padding: 50px 0;

    &__header {
        font-family: PPAgrandir-Medium, sans-serif;
        font-size: 2.8rem;
    }

    &__description {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.6rem;
        text-align: center;
    }
}
</style>
